var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcResult({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2333 9.97998H9.23333V10.98H14.2333V9.97998Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2333 11.98H9.23333V12.98H14.2333V11.98Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2333 13.98H9.23333V14.98H14.2333V13.98Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73333 3.47998V13.98C1.73333 14.5333 2.18 14.98 2.73333 14.98H8.23333V13.98H2.73333V3.47998H4.23333V4.97998H10.2333V3.47998H11.7333V8.93331H12.7333V3.47998C12.7333 2.92665 12.2867 2.47998 11.7333 2.47998H10.2333V1.97998C10.2333 1.42665 9.78667 0.97998 9.23333 0.97998H5.23333C4.68 0.97998 4.23333 1.42665 4.23333 1.97998V2.47998H2.73333C2.18 2.47998 1.73333 2.92665 1.73333 3.47998ZM5.23333 1.97998H9.23333V3.97998H5.23333V1.97998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResult);
export default __webpack_public_path__ + "static/media/ic-result.f5ec61b8a2b31050af2993526c10f5b2.svg";
export { ForwardRef as ReactComponent };